export default "__VITE_ASSET__8fc60af5__"